import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CURATED_POSTS } from './InstagramFeed';
import { socialLinks } from '../data/siteLinks';

const InstagramSection: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const updateButtons = useCallback(() => {
    const el = trackRef.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);

  useEffect(() => {
    updateButtons();
    const el = trackRef.current;
    if (!el) return;
    el.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    return () => {
      el.removeEventListener('scroll', updateButtons);
      window.removeEventListener('resize', updateButtons);
    };
  }, [updateButtons]);

  const scrollByStep = (direction: 1 | -1) => {
    const el = trackRef.current;
    if (!el) return;
    const card = el.querySelector<HTMLElement>('.instagram-home-card');
    const step = card ? card.offsetWidth + 24 : el.clientWidth * 0.8;
    el.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  return (
    <section id="instagram" className="youtube-section instagram-home-section">
      <div className="container">
        <div className="social-platform-heading">
          <span className="social-platform-icon social-platform-icon-instagram" aria-hidden="true">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <defs>
                <radialGradient
                  id="instagram-heading-gradient"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(5 20) rotate(-49) scale(25)"
                >
                  <stop stopColor="#FFD600" />
                  <stop offset="0.42" stopColor="#FF7A00" />
                  <stop offset="0.68" stopColor="#FF0169" />
                  <stop offset="1" stopColor="#D300C5" />
                </radialGradient>
              </defs>
              <rect x="1" y="1" width="22" height="22" rx="6" fill="url(#instagram-heading-gradient)" />
              <rect x="6" y="6" width="12" height="12" rx="3.5" stroke="#fff" strokeWidth="1.7" />
              <circle cx="12" cy="12" r="2.8" stroke="#fff" strokeWidth="1.7" />
              <circle cx="16.2" cy="7.8" r="1" fill="#fff" />
            </svg>
          </span>
          <h3 className="social-platform-title">Instagram</h3>
          <a className="social-platform-handle" href={socialLinks.instagram} target="_blank" rel="noopener noreferrer">
            @aysegulsaraccom <span aria-hidden="true">↗</span>
          </a>
        </div>
        <p className="youtube-description">
          Almanya’ya göç, yerleşim süreçleri ve günlük yaşama dair önemli bilgileri, deneyimleri ve göç
          hikâyelerini Instagram paylaşımlarımızda bulabilirsiniz.
        </p>
        <div className="youtube-carousel">
          <button
            type="button"
            className="youtube-arrow youtube-arrow-prev"
            onClick={() => scrollByStep(-1)}
            disabled={!canPrev}
            aria-label="Önceki Instagram gönderileri"
          >
            <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 3L3 19L19 35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <div className="youtube-grid" ref={trackRef}>
            {CURATED_POSTS.map((post) => (
              <a
                key={post.id}
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="youtube-card instagram-home-card"
                aria-label="Instagram gönderisini aç"
              >
                <div className="youtube-thumbnail instagram-home-thumbnail">
                  <img src={post.image} alt="Ayşegül Saraç Instagram gönderisi" loading="lazy" />
                  <span className="instagram-home-mark" aria-hidden="true">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
                      <circle cx="12" cy="12" r="4.2" stroke="currentColor" strokeWidth="1.8" />
                      <circle cx="17.4" cy="6.7" r="1.1" fill="currentColor" />
                    </svg>
                  </span>
                </div>
              </a>
            ))}
          </div>

          <button
            type="button"
            className="youtube-arrow youtube-arrow-next"
            onClick={() => scrollByStep(1)}
            disabled={!canNext}
            aria-label="Sonraki Instagram gönderileri"
          >
            <svg width="22" height="38" viewBox="0 0 22 38" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 3L19 19L3 35" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="youtube-channel-link">
          <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="btn btn-teal">
            Tüm Gönderiler
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramSection;
